var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(_vm.datatype !== 'privacy-yy')?_c('Header',{staticClass:"header",attrs:{"resData":_vm.pagedata.nav}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"main"},[_c(_vm.mainshow,{tag:"component",attrs:{"resData":_vm.pagedata[_vm.datatype]}})],1),_vm._v(" "),_c('Footer',{attrs:{"resData":_vm.pagedata.footer}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f10643a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/index.vue
// module id = null
// module chunks = 